/* tslint:disable */
/* eslint-disable */
/**
 * Business Portal API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
import type { CompaniesResponseCompanyName } from './CompaniesResponseCompanyName';
import {
    CompaniesResponseCompanyNameFromJSON,
    CompaniesResponseCompanyNameFromJSONTyped,
    CompaniesResponseCompanyNameToJSON,
    CompaniesResponseCompanyNameToJSONTyped,
} from './CompaniesResponseCompanyName';

/**
 * 
 * @export
 * @interface CompaniesResponse
 */
export interface CompaniesResponse {
    /**
     * 会社一覧
     * @type {Array<CompaniesResponseCompanyName>}
     * @memberof CompaniesResponse
     */
    companies: Array<CompaniesResponseCompanyName>;
}

/**
 * Check if a given object implements the CompaniesResponse interface.
 */
export function instanceOfCompaniesResponse(value: object): value is CompaniesResponse {
    if (!('companies' in value) || value['companies'] === undefined) return false;
    return true;
}

export function CompaniesResponseFromJSON(json: any): CompaniesResponse {
    return CompaniesResponseFromJSONTyped(json, false);
}

export function CompaniesResponseFromJSONTyped(json: any, ignoreDiscriminator: boolean): CompaniesResponse {
    if (json == null) {
        return json;
    }
    return {
        
        'companies': ((json['companies'] as Array<any>).map(CompaniesResponseCompanyNameFromJSON)),
    };
}

export function CompaniesResponseToJSON(json: any): CompaniesResponse {
    return CompaniesResponseToJSONTyped(json, false);
}

export function CompaniesResponseToJSONTyped(value?: CompaniesResponse | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'companies': ((value['companies'] as Array<any>).map(CompaniesResponseCompanyNameToJSON)),
    };
}

